import React, { useState } from 'react';
import ReactSelect from 'react-select';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';

import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  InputAdornment,
  makeStyles,
  TextField,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import SendIcon from '@material-ui/icons/Send';
import flespiDeviceService from '../../../../services/FlespiDeviceService';
import toast from 'react-hot-toast';

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: '#757575',
    fontWeight: '700'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary
  },
  accordionSummaryDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  settingsDiv: {
    marginRight: '12px'
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column'
  },

  accordionDetailsItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1rem'
  },
  divContainer: {
    display: 'flex',
    flex: 1,
    marginBottom: '1rem'
  },
  form: {
    width: '100%'
  }
}));

const prioOptions = [
  { value: 'disable', label: 'Disable', id: 0 },
  { value: 'low', label: 'Low', id: 1 },
  { value: 'high', label: 'High', id: 2 },
  { value: 'panic', label: 'Panic', id: 3 }
];

const OverSpeeding = ({ overSpeedingRecord }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const [loading, setLoading] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {
      max_speed: overSpeedingRecord[0]?.current?.max_speed,
      prio: overSpeedingRecord[0]?.current?.prio
    }
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleOverSpeedingSubmit = (data) => {
    // eslint-disable-next-line no-console, no-undef
    console.log(data);
    setLoading(true);

    let overSpeedingPayload = {
      deviceId: overSpeedingRecord[0]?.device_id,
      settSelector: 'overspeeding_obd',
      properties: {
        prio: data.prio,
        max_speed: data.max_speed
      }
    };

    flespiDeviceService
      .updateFlespiDeviceSetting(overSpeedingPayload)
      .then((data) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('data is:', data);
        toast.success('Successfully updated over speeding settings');
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error', error?.response?.data?.message);
        toast.error(error?.response?.data?.message || 'Unable to update over speeding settings');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className={classes.divContainer}>
      <form onSubmit={handleSubmit(handleOverSpeedingSubmit)} className={classes.form}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1bh-header">
            <div className={classes.accordionSummaryDiv}>
              <div className={classes.settingsDiv}>
                <SettingsIcon />
              </div>

              <div>
                <Typography className={classes.heading}>Overspeeding</Typography>
                <Typography className={classes.secondaryHeading}>Overspeeding scenario settings</Typography>
              </div>
            </div>
          </AccordionSummary>

          <Divider />

          <AccordionDetails className={classes.accordionDetails}>
            <Typography style={{ color: '#9e9e9e ' }}>Overspeeding</Typography>

            {/* prio */}
            <div style={{ marginBottom: '1rem' }}>
              <Controller
                name="prio"
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    options={prioOptions}
                    isSearchable
                    value={prioOptions?.find((option) => option.id === field.value)}
                    onChange={(selected) => field.onChange(selected ? selected.id : null)}
                    classNamePrefix="select"
                    name="prio"
                    // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 2 }) }}
                  />
                )}
              />
              {errors.prio && (
                <Typography color="error" style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>
                  {errors.prio.message}
                </Typography>
              )}
            </div>

            {/* max_speed */}
            <div className={classes.accordionDetailsItem}>
              <Controller
                name="max_speed"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Max Acceleration"
                    name="max_speed"
                    size="small"
                    type="number"
                    fullWidth
                    variant="outlined"
                    {...field}
                    error={!!errors.max_speed}
                    helperText={errors.max_speed?.message}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">m/sec^2</InputAdornment>
                    }}
                  />
                )}
              />
            </div>
          </AccordionDetails>

          <AccordionActions style={{ cursor: 'pointer' }}>
            <Button
              size="small"
              color="primary"
              title="Changes will apply to the device"
              type="submit"
              disabled={loading}
            >
              <SendIcon />
            </Button>
          </AccordionActions>
        </Accordion>
      </form>
    </div>
  );
};

export default OverSpeeding;

OverSpeeding.propTypes = {
  overSpeedingRecord: PropTypes.any
};
